import EdgeStyleContainer from "../../../Components/Buttons/EdgeStyle/EdgeStyle"

const EdgeStyle = () => {
  return (
    <div className='page-body'>
      <EdgeStyleContainer />
    </div>
  )
}

export default EdgeStyle